import toast from 'react-hot-toast';
import {
  ADD_EVENT,
  COPY_PAIR,
  CREATE_SCHEDULER,
  DELETE_EVENTS_PAIR,
  EDIT_EVENT_PAIR,
  EDIT_SCHEDULER,
  GET_SCHEDULERS_SUCCESS,
  MOVE_PAIR,
  REMOVE_SCHEDULER,
  SHOW_ERROR,
} from '../constant';

const initial = {
  schedulers: [],
  schedulerError: '',
};

export const SchedulerReducer = (state = initial, action) => {
  switch (action.type) {
    case GET_SCHEDULERS_SUCCESS:
      return {
        ...state,
        schedulers: action.payload,
      };
    case SHOW_ERROR:
      return {
        ...state,
        schedulerError: action.payload,
      };
    case CREATE_SCHEDULER:
      state.schedulers.push({ ...action.payload, events: [] });
      return {
        ...state,
        schedulers: state.schedulers,
      };
    case EDIT_SCHEDULER:
      const index = state.schedulers.findIndex(
        (sch) => sch._id == action.payload._id
      );
      state.schedulers[index].color = action.payload.color;
      state.schedulers[index].name = action.payload.name;
      return {
        ...state,
        schedulers: state.schedulers,
      };
    case REMOVE_SCHEDULER:
      return {
        ...state,
        schedulers: state.schedulers.filter(
          (sch) => sch._id !== action.payload
        ),
      };
    case ADD_EVENT:
      const schedulerToEdit = state.schedulers.find(
        (sch) => sch._id == action.payload?.eventStart?.group
      );
      if (!schedulerToEdit) return state;
      return {
        ...state,
        schedulers: state.schedulers.map((sch) =>
          sch._id === schedulerToEdit._id
            ? {
                ...sch,
                events: [
                  ...sch.events,
                  action.payload.eventStart,
                  action.payload.eventStop,
                ],
              }
            : sch
        ),
      };
    case EDIT_EVENT_PAIR:
      const schedulerToEditAlt = state.schedulers.find(
        (sch) => sch._id == action.payload?.startEvent?.group
      );
      if (!schedulerToEditAlt) return state;
      return {
        ...state,
        schedulers: state.schedulers.map((sch) =>
          sch._id === schedulerToEditAlt._id
            ? {
                ...sch,
                events: [
                  ...sch.events.filter(
                    (e) =>
                      e._id !== action.payload?.startEvent?._id &&
                      e._id !== action.payload?.endEvent?._id
                  ),
                  action.payload?.startEvent,
                  action.payload?.endEvent,
                ],
              }
            : sch
        ),
      };
    case DELETE_EVENTS_PAIR:
      const schedulerToEditA = state.schedulers.find(
        (sch) => sch._id == action.payload?.schedulerId
      );
      if (!schedulerToEditA) return state;
      console.log(schedulerToEditA);
      return {
        ...state,
        schedulers: state.schedulers.map((sch) =>
          sch._id === schedulerToEditA._id
            ? {
                ...sch,
                events: sch.events.filter(
                  (e) => e.pair != action.payload.pairId
                ),
              }
            : sch
        ),
      };
    case MOVE_PAIR:
      const sourceScheduler = state.schedulers.find(
        (sch) => sch._id == action.payload.oldScheduler
      );
      const targetScheduler = state.schedulers.find(
        (sch) => sch._id == action.payload.scheduler
      );
      if (!sourceScheduler || !targetScheduler) return state;
      const eventsToMove = sourceScheduler.events.filter(
        (e) => e.pair == action.payload.pairId
      );
      return {
        ...state,
        schedulers: state.schedulers.map((sch) => {
          if (sch._id === action.payload.scheduler) {
            return { ...sch, events: [...sch.events, ...eventsToMove] };
          }
          if (sch._id === action.payload.oldScheduler) {
            return {
              ...sch,
              events: sch.events.filter(
                (e) => e.pair !== action.payload.pairId
              ),
            };
          }
          return sch;
        }),
      };
    case COPY_PAIR:
      const targetSchedulerForCopy = state.schedulers.find(
        (sch) => sch._id == action.payload.scheduler
      );
      if (!targetSchedulerForCopy) return state;
      toast.success('Successfully copied');
      return {
        ...state,
        schedulers: state.schedulers.map((sch) =>
          sch._id === action.payload.scheduler
            ? { ...sch, events: [...sch.events, ...action.payload.pairs] }
            : sch
        ),
      };
    default:
      return state;
  }
};
